var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"modal"}},[_c('div',{class:[
      'modal-portal',
      { 'overlay-bg': _vm.show },
      { 'blue-bg': _vm.isCustomBg },
    ]},[_c('transition',{attrs:{"name":"fade","appear":""}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }